export default "__VITE_ASSET__4ystpuQ3__"